// Primary path names
export const pathNames = {
  payroll: 'manadsrapportering',
  payrollHelp: 'hjalp',
  reportPayroll: 'rapportering',
  employments: 'administrera-arbetare',
  employmentsHelp: 'hjalp',
  editEmployment: 'andra',
  addEmployment: 'lagg-till',
  editEmployee: 'andra-anstalld',
  addEmployee: 'lagg-till-anstalld',
  editEmploymentPeriod: 'andra-anstallningsperiod',
  addEmploymentPeriod: 'lagg-till-anstallningsperiod',
  editParameter: 'andra-tillagg',
  invoices: 'fakturor',
  invoicesHelp: 'hjalp',
  markups: 'foretagets-uppmarkningar',
  fileDashboard: 'lonerapportering',
  fileDashboardHelp: 'hjalp',
  payHistory: 'registrerade-loner',
  reportHistory: 'rapporteringshandelser',
} as const;

export type PathKeys = keyof typeof pathNames;

// Add alternative path names
export const pathNameVariations: { [key in PathKeys]: string[] } = {
  payroll: [pathNames.payroll, 'månadsrapportering', 'payroll'],
  payrollHelp: [pathNames.payrollHelp, 'hjälp', 'help'],
  reportPayroll: [pathNames.reportPayroll, 'report-payroll'],
  employments: [pathNames.employments, 'employments'],
  employmentsHelp: [pathNames.employmentsHelp, 'hjälp', 'help'],
  addEmployment: [pathNames.addEmployment, 'lägg-till', 'add-employment'],
  editEmployment: [pathNames.editEmployment, 'ändra', 'edit-employment'],
  editEmployee: [pathNames.editEmployee, 'ändra-anställd', 'edit-employee'],
  addEmployee: [pathNames.addEmployee, 'lägg-till-anställd', 'add-employee'],
  editEmploymentPeriod: [pathNames.editEmploymentPeriod, 'ändra-anställningsperiod', 'edit-employment-period'],
  addEmploymentPeriod: [pathNames.addEmploymentPeriod, 'lägg-till-anställningsperiod', 'add-employment-period'],
  editParameter: [pathNames.editParameter, 'ändra-tillägg', 'edit-add-on'],
  invoices: [pathNames.invoices, 'invoices'],
  invoicesHelp: [pathNames.invoicesHelp, 'hjälp', 'help'],
  markups: [pathNames.markups, 'företagets-uppmärkningar', 'markups'],
  fileDashboard: [pathNames.fileDashboard, 'lönerapportering', 'pay-reporting'],
  fileDashboardHelp: [pathNames.fileDashboardHelp, 'hjälp', 'help'],
  payHistory: [pathNames.payHistory, 'registrerade-löner', 'registered-pays'],
  reportHistory: [pathNames.reportHistory, 'rapporteringshändelser', 'reporting-events'],
};

/** Dynamic segments (path parameters)  */

export const payMonthParam = 'payMonth';
export type ReportPayrollParams = { [payMonthParam]: string };
export const policyNumberParam = 'policyNumber';
export const employmentPeriodIndexParam = 'employmentPeriodIndex';
export type EditEmploymentParams = { [policyNumberParam]: string };
export type EditEmploymentPeriodParams = { [policyNumberParam]: string; [employmentPeriodIndexParam]: string };

export const routePaths: { [key in PathKeys]: string[] } = {
  ...pathNameVariations,
  reportPayroll: pathNameVariations.reportPayroll.map(path => `${path}/:${payMonthParam}`),
  editEmployment: pathNameVariations.editEmployment.map(path => `${path}/:${policyNumberParam}`),
  editEmployee: pathNameVariations.editEmployee.map(path => `${path}/:${policyNumberParam}`),
  editEmploymentPeriod: pathNameVariations.editEmploymentPeriod.map(
    path => `${path}/:${policyNumberParam}/:${employmentPeriodIndexParam}`
  ),
  addEmploymentPeriod: pathNameVariations.addEmploymentPeriod.map(path => `${path}/:${policyNumberParam}`),
  editParameter: pathNameVariations.editParameter.map(
    path => `${path}/:${policyNumberParam}/:${employmentPeriodIndexParam}`
  ),
};
